import apiClientCreator from "../../helpers/api/request";

// eslint-disable-next-line no-unused-vars
export async function getTaskDictionary({ commit, state }) {
  try {
    let apiClient = apiClientCreator("tasks/dictionary");
    let response = await apiClient.get();

    commit("tasks/setTaskDictionary", response.data, { root: true });
    return response;
  } catch (e) {}
}

export async function fetchTasks({ commit, state }) {
  try {
    let apiClient = apiClientCreator("tasks/list");
    let response = await apiClient.get();
    let activeTasks = response.data.data.filter(
      task => task.user_status.status_id === 3
    );
    commit("tasks/setTasks", activeTasks, { root: true });
  } catch (err) {}
}

export async function fetchActiveTasks({ commit, state }) {
  try {
    // let apiClient = apiClientCreator("tasks/list");
    let apiClient = apiClientCreator("tasks/users/active_tasks_count");
    let response = await apiClient.get("");
    // let activeTasks = response.data.data.filter(
    //   task => task.user_status.status_id === 3
    // );
    commit("tasks/setActiveTasks", response.data, { root: true });
  } catch (err) {}
}
export async function fetchAllActiveTasks({ commit, state }) {
  try {
    let apiClient = apiClientCreator("tasks/users/active_tasks");
    let response = await apiClient.get();
    // let activeTasks = responseActiveTasks.data.data.filter(task => task.user_status.status_id == 3);
    commit("tasks/setAllActiveTasks", response, { root: true });
  } catch (err) {}
}

export async function fetchActiveTasksCounter({ commit, state }) {
  try {
    let apiClient = apiClientCreator("tasks/stats/group/active");
    let response = await apiClient.get();
    commit("tasks/setActiveTasksCounter", response.data[0], {
      root: true
    });
    commit("tasks/setActiveMeetingsCounter", response.data[1], { root: true });
  } catch (err) {}
}

export async function updateActiveTimer({ commit, state }) {
  try {
    commit("tasks/setActiveTimer", state, { root: true });
  } catch (err) {}
}
export async function getTopFiveTagsFromLast100({ commit, state }) {
  try {
    let apiClient = apiClientCreator(`tasks/stats/top_five_tags`);
    let response = await apiClient.get();
    let topFiveTags = Object.keys(response.data)
      .map(key => ({
        cat_id: Number(key),
        count: response.data[key]
      }))
      .sort(function(a, b) {
        return b.count - a.count;
      })
      .slice(0, 5);
    commit("tasks/setTopFiveTagsFromLast100", topFiveTags, { root: true });
  } catch (err) {}
}

export async function getTopThreeUsersFromLast100({ commit, state }) {
  try {
    let apiClient = apiClientCreator(`tasks/stats/top_three_users`);
    let response = await apiClient.get();
    commit("tasks/setTopThreeUsersFromLast100", response, { root: true });
  } catch (err) {}
}

export async function getPreOpenTaskFromChart({ commit, state }, opt) {
  try {
    if (state.preOpenTaskFromChart === false && opt.preOpen === true) {
      commit("tasks/setPreOpenTaskFromChart", true, { root: true });
    } else if (state.preOpenTaskFromChart === true && opt.preOpen === false) {
      commit("tasks/setPreOpenTaskFromChart", false, { root: true });
    } else if (state.preOpenTaskFromChart === true && opt.preOpen === true) {
      if (opt.newTagId === state.chartDataToTable.tagId) {
        commit("tasks/setPreOpenTaskFromChart", true, { root: true });
      } else {
        commit("tasks/setPreOpenTaskFromChart", false, { root: true });
      }
    }
  } catch (err) {}
}

export async function getCategories({ commit, state }) {
  try {
    let apiClient = apiClientCreator(`tasks/category/`);
    let response = await apiClient.get();
    commit("tasks/setCategories", response, { root: true });
  } catch (err) {}
}
